import http from './httpService';
import config from '../configs/config.js';
import references from '../configs/reference.json';
import qs from 'qs';
import masking from '../configs/masking.json'
const url = config.apiEndPoint + '/summary';

function generateURL(path) {
  return `${url}/${path}`;
}

// 1. Get Summary
export async function getSummaries(data) {
  let params = {
    mindate: data.mindate,
    maxdate: data.maxdate,
    level: data.level,
    skip: data.skip,
    limit: data.limit
  };
  let summary = await http.get(url, {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });

  
  return summary;
}

// 2. Get Summary Categories
export async function getSummaryCategories(data) {
  let params = {
    mindate: data.mindate,
    maxdate: data.maxdate
  };
  let category = await http.get(generateURL('category'), { params: params });

  return category;
}

// 3. Get Summary Date
export async function getSummaryDates() {
  let data = await http.get(generateURL('date'));
  return data;
}

// 4. Get Filter Values
export async function getSummaryFilter(data) {
  let params = {
    column: data.column,
    date: data.date
  };
  let filter = await http.get(generateURL('filter'), { params: params });
  return filter;
}
